import { render, staticRenderFns } from "./CourseSetModal.vue?vue&type=template&id=0a4af3ab"
import script from "./CourseSetModal.vue?vue&type=script&lang=js"
export * from "./CourseSetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports